<template>
  <DrawerSlot>
    <div :class="style.wrapper">
      <DrawerPresentational
        :items="menus"
        :get-show-flags="getShowFlg"
        :router-push="routerPush"
      />
    </div>
  </DrawerSlot>
</template>

<script>
import { mapGetters } from 'vuex'
import DrawerPresentational from '@/components/Shared/Drawer/DrawerPresentational'
import { Account } from '@/models/Account'
import standard from '@/assets/images/advertiser/standard@2x.png'
import drawerStyles from '@/components/Shared/Drawer/drawerStyles'
import progress from '@/assets/images/advertiser/progress@2x.png'
// import split from '@/assets/images/advertiser/split@2x.png'
import creative from '@/assets/images/advertiser/image.png'
import geo from '@/assets/images/advertiser/geo@2x.png'
// import custom from '@/assets/images/advertiser/custom@2x.png'
// import interval from '@/assets/images/advertiser/interval@2x.png'
import svg from '@/assets/images/advertiser/svg@2x.png'
import simulation from '@/assets/images/advertiser/simulation@2x.png'
import reportExport from '@/assets/images/advertiser/reportExport.png'
import personPin from '@/assets/images/advertiser/person-pin@2x.png'

import DrawerSlot from '@/components/Shared/Drawer/DrawerSlot'

// メニュー内容作成にあたって必要最低限の情報
const itemsBase = [
  {
    title: '標準レポート',
    path: 'standard_reports',
    image: standard,
    width: 20,
    height: 20,
  },
  {
    title: '予算進捗',
    path: 'budget_progress_reports',
    image: progress,
    width: 20,
    height: 20,
  },
  {
    title: 'レポート出力',
    path: 'interval_reports',
    image: reportExport,
    width: 20,
    height: 20,
  },
  {
    title: 'マップレポート',
    path: 'map_reports',
    image: geo,
    width: 20,
    height: 20,
  },
  {
    title: '地点管理',
    path: 'point_groups',
    image: personPin,
    width: 20,
    height: 20,
  },
  // {
  //   title: 'メニュー',
  //   path: 'menu',
  //   image: geo,
  //   width: 20,
  //   height: 20,
  // },
  {
    title: 'キャンペーン管理',
    path: 'insertion_orders',
    image: svg,
    width: 20,
    height: 20,
  },
  {
    title: 'クリエイティブ管理',
    path: 'creatives',
    image: creative,
    width: 20,
    height: 20,
  },
  {
    title: 'シミュレーション',
    path: 'simulations',
    image: simulation,
    width: 20,
    height: 20,
  },
  // {
  //   title: '配信先リスト',
  //   path: 'inventory_list_targeting',
  //   image: geo,
  //   width: 20,
  //   height: 20,
  // },
  // {
  //   title: 'IPアドレスリスト',
  //   path: 'ip_address_list_targeting',
  //   image: geo,
  //   width: 20,
  //   height: 20,
  // },
  //  {
  //    title: 'クリエイティブ',
  //    path: 'creative_reports',
  //    image: creative,
  //    width: 11,
  //    height: 17,
  //  },
  //  {
  //    title: '地図',
  //    path: 'geo_reports',
  //    image: geo,
  //    width: 16,
  //    height: 17,
  //  },
  //  {
  //    title: 'カスタム',
  //    path: 'custom_reports',
  //    image: custom,
  //    width: 15,
  //    height: 16,
  //  },
  //  {
  //    title: '定期実行',
  //    path: 'interval_reports',
  //    image: interval,
  //    width: 15,
  //    height: 15,
  //  },
]

// itemsBase を元に、Presentational Component に渡す item を作成する関数
const itemsBaseToItems = ({ items, agencyId, advertiserId }) => {
  return items.map(o => {
    const title = o.title
    const url = `/agencies/${agencyId}/advertisers/${advertiserId}/${o.path}`
    const image = o.image
    const width = o.width
    const height = o.height
    return { title, url, image, width, height }
  })
}

export default {
  title: 'AdvertiserDrawer',
  components: { DrawerPresentational, DrawerSlot },
  data() {
    return {
      menus: [],
      isHideRevenue: undefined,
    }
  },
  computed: {
    ...mapGetters('currentAdvertiser', ['currentAdvertiser']),
    ...mapGetters('account', ['isSimulationVisible']),
    getShowFlg() {
      return this.$store.getters['drawerUriAuths/getShowFlg']
    },
    color() {
      return this.$store.getters['colorTheme/color']
    },
    style() {
      return drawerStyles(this.color)
    },
    userBelongType() {
      return this.$store.getters['account/belongType']
    },
    userBelongId() {
      return this.$store.getters['account/belongId']
    },
    userType() {
      return this.$store.getters['account/userType']
    },
  },

  watch: {
    // FIXME: linear GL-247によるハードコード
    async userBelongType() {
      // 左サイドバーのメニューを組み立てる
      this.setMenus()
      // 左サイドバーのメニュー配列に対して、それぞれ権限を表示する
      this.setPermissionForMenus()
    },
  },
  async created() {
    // accountの情報をgetしておく
    await this.$store.dispatch('account/GET')
    await this.setIsHideRevenue()
    // 左サイドバーのメニューを組み立てる
    this.setMenus()
    // 左サイドバーのメニュー配列に対して、それぞれ権限を表示する
    this.setPermissionForMenus()
  },
  methods: {
    async setIsHideRevenue() {
      if (!this.userBelongType || !this.userBelongId) return

      this.isHideRevenue = await Account.isHideRevenue(
        this.userBelongType,
        this.userBelongId,
        this.userType,
      )
    },
    setMenus() {
      if (this.currentAdvertiser == null || this.isHideRevenue === undefined)
        return []

      const { agencyId } = this.currentAdvertiser
      const advertiserId = this.currentAdvertiser.id
      const itemsBaseWithIsHideRevenue = this.isHideRevenue
        ? itemsBase.filter(
            item =>
              ![
                'budget_progress_reports',
                'interval_reports',
                'simulations',
              ].includes(item.path),
          )
        : itemsBase

      const items = this.isSimulationVisible
        ? itemsBaseWithIsHideRevenue
        : itemsBaseWithIsHideRevenue.filter(item => item.path !== 'simulations')

      this.menus = itemsBaseToItems({
        items,
        agencyId,
        advertiserId,
      })
    },
    routerPush(path) {
      this.$router.push({ path }).catch(() => {})
    },
    setPermissionForMenus() {
      const uriPaths = this.menus.map(o => o.url)
      const payload = {
        uriPaths,
      }
      this.$store.dispatch('drawerUriAuths/INITIALIZE', payload)
    },
  },
}
</script>

<style scoped></style>
